export const postDateFormat = "dd MMM y, HH:mm";
export const purchaseDateFormat = "dd MMM y";
export const incomeFormat = "dd MMM yyyy";
export const scheduledDateFormat = "yyyy-MM-dd";
